import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import styled from "styled-components"

/*global affirm*/

const AffirmLink = styled.a`
  color: ${(props) => props.theme.colors.link};
  cursor: pointer;
  display: block;
  font-size: 12px;
  min-height: 18px;
  & > span {
    border-bottom: 1px solid;
  }
`

let affirmPrice = null
const InternalAffirm = ({ logoColor = null, pricing }) => {
  if (pricing.show_affirm) {
    return (
      <AffirmLink>
        <span
          className="affirm-as-low-as"
          data-affirm-color={logoColor}
          data-amount={pricing.price_to_display * 100}
          data-learnmore-show="false"
          data-page-type="product"
          ref={() => {
            if (
              typeof affirm !== "undefined" &&
              affirm.ui &&
              affirm.ui.refresh &&
              affirmPrice != pricing.price_to_display * 100
            ) {
              affirm.ui.refresh()
              affirmPrice = pricing.price_to_display * 100
            }
          }}
        />
      </AffirmLink>
    )
  } else {
    return ""
  }
}

InternalAffirm.propTypes = {
  logoColor: PropTypes.string,
  pricing: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    pricing: state.wizardUI.currentPricing,
  }
}

const Affirm = connect(mapStateToProps)(InternalAffirm)

export default Affirm
